import { SyntheticEvent, useEffect, useState } from 'react';
import { Field, useField } from 'formik';
import { Autocomplete, AutocompleteRenderInputParams } from 'formik-mui';
import TextField from '@mui/material/TextField';
import styled from '@emotion/styled';
import { FieldHookConfig } from 'formik/dist/Field';
import { OwnerDto } from '../../../../../api/services/dto/user-managment-dto/owner-dto';
import { warrantService } from '../../../../../api/services/warrant.service';


export const SelectOwner = (
  props: { selected: OwnerDto; setCustomDirtyState: () => void, helperText: boolean } & FieldHookConfig<
    OwnerDto
  >,
) => {
  const [owners, setOwners] = useState<OwnerDto[]>([]);
  const [selected, setSelected] = useState<OwnerDto>(props.selected);
  const [field, _, helper] = useField(props);

  // Update state when props change. TODO: Can this be done better?
  useEffect(() => {
    warrantService.fetchOwners().then(owners => {
      setOwners(owners);
    });
   
  }, []);

  useEffect(() => {
    setSelected(props.selected);
  },[props.selected]);

  /**
   * Used for setting the selected values from props
   * This would not be needed it the AutoComplete component would be using the ids instead of objects:
   * https://github.com/mui/material-ui/issues/23708
   * https://github.com/mui/material-ui/issues/37287
   */
  useEffect(() => {
    // reactive dependencies ftw.
    if (owners.length === 0 || selected.userId.length === 0) {
      return;
    }
    // Set the already selected values
    console.log(`Selected owners: ${selected}`);
    helper
      .setValue(
        selected ?? { ownerId: '', email: '' },
        true,
      )
      .then();
  }, [owners, selected]);

  return (
    <Wrapper>
      <Field
        id={'owner'}

        className='buyer-pro-autocomplete owner-autocomplete'
        {...field}
        component={Autocomplete}
        options={owners}
        getOptionLabel={(owner: OwnerDto) => owner.fullName || ''}
        isOptionEqualToValue={(option: OwnerDto, value: OwnerDto) => option.userId === value.userId}
        onChange={(_: SyntheticEvent, newValue: OwnerDto) => {
          props.setCustomDirtyState();
          return helper.setValue(newValue, false).catch();
        }}
        renderInput={(params: AutocompleteRenderInputParams) => (

          <TextField
            name={'owner'}

            label={'Select a owner'}
            placeholder='Optional'
            variant='outlined'
            error={props.helperText}
            helperText={props.helperText ? 'Select a owner' : undefined}
            {...params}
          />
        )}
      />
    </Wrapper>
  );
};

export default SelectOwner;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  margin-bottom: 24px;
`;
